import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { AdminCreateFullAttendanceDto } from "@interfaces/dto/adminCreateFullAttendanceDto.interface";
import { FobScannedDto } from "@interfaces/dto/fobScannedDto.interface";
import { GenerateStaffAttendanceReportCsv } from "@interfaces/generateStaffAttendanceReportCsv.interface";
import { TimeReportForUser } from "@interfaces/timeReportForUser.interface";
import { Service } from "@services/service";

@Injectable()
export class StaffAttendanceService extends Service {
	constructor(injector: Injector) {
		super("StaffAttendance", injector);
	}

	// API
	adminCreateFullAttendance(data: AdminCreateFullAttendanceDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/AdminCreateFullAttendance/`, data);
	}
	
	adminFobScanned(fobScanned: FobScannedDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/AdminFobScanned/`, fobScanned);
	}
	
	app_currentStatusForSite(siteId: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/App_CurrentStatusForSite/${siteId}`);
	}
	
	app_fobScanned(fobScanned: FobScannedDto) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/App_FobScanned/`, fobScanned);
	}

	forSite(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForSite/${id}`);
	}

	forUserProfile(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForUserProfile/${id}`);
	}

	generateReport(parameters: GenerateStaffAttendanceReportCsv) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/GenerateReport`, parameters, { responseType: "blob" as "json"} );
	}

	heatMapForUserProfile(userProfileId: number, fromDate: Date, toDate: Date) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/HeatMapForUserProfile/${userProfileId}/${fromDate.toDateString()}/${toDate.toDateString()}`);
	}

	openSessionForUserProfile(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OpenSessionForUserProfile/${id}`);
	}

	timeReportForUser(parameters: TimeReportForUser) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/TimeReportForUser`, parameters );
	}
}